module.exports = __webpack_public_path__ + "img/GPS52-note.5de55027.png";